import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useCreateStaffManager, useUpdateStaffManager } from "../../../apis";
import {
  getInitialManagerFormValues,
  convertManagerFormDataToUpdateBody
} from "../../../helpers";
import { StaffManagerForm } from "../../forms";
import { StaffManagerFormValues } from "../../forms/StaffManagerForm/StaffManagerForm.types";
import { StaffManagerModalProps } from "../components.types";

const STAFF_MANAGER_FORM_ID = "staff-manager-form-id";

const StaffManagerModal = ({
  isOpen,
  onClose,
  editableManager,
  refetchManagers
}: StaffManagerModalProps) => {
  const {
    mutate: mutateCreateStaffManager,
    isLoading: isCreateStaffManagerLoading
  } = useCreateStaffManager({
    onSuccess: () => {
      toast.success(t("Staff Manager created successfully"));
      onClose();
      refetchManagers();
    }
  });

  const { mutate: mutateUpdateStaffManager } = useUpdateStaffManager({
    onSuccess: () => {
      toast.success(t("Staff Manager updated successfully"));
      onClose();
      refetchManagers();
    }
  });

  const updateStaff = (formData: StaffManagerFormValues) => {
    const beforeUpdateFormData = getInitialManagerFormValues(editableManager);
    const body = convertManagerFormDataToUpdateBody(
      beforeUpdateFormData,
      formData
    );
    mutateUpdateStaffManager(body);
  };

  const createStaff = (formData: StaffManagerFormValues) => {
    const body = {
      ...formData,
      imageId: formData.image?.id ?? null
    };
    mutateCreateStaffManager(body);
  };

  const handleFormSubmit = (formData: StaffManagerFormValues) => {
    if (formData.id) updateStaff(formData);
    else createStaff(formData);
  };

  return (
    <Modal
      formId={STAFF_MANAGER_FORM_ID}
      isOpen={isOpen}
      title={`${editableManager ? "Edit" : "New"} Manager`}
      isLoading={isCreateStaffManagerLoading}
      okText={editableManager ? "Save" : "Create"}
      onClose={onClose}
    >
      <StaffManagerForm
        formId={STAFF_MANAGER_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={getInitialManagerFormValues(editableManager)}
      />
    </Modal>
  );
};

export default StaffManagerModal;
